import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import axios from 'axios';
import { api } from '../Costants';
import ReactLoading from "react-loading";
import Breadcrumb from '../Breadcrumb/Breadcrumb';

function BlogDetails() {
  const { blog_id } = useParams();
  const location = useLocation();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    axios.post(`${api}blog_list`).then(res => {
      if (res.data.status === 200) {
        const match = res.data.records.find(item => item.id === blog_id);
        setBlog(match);
        setLoading(false);
      }
    });
  }, [blog_id]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '80vh' }}>
        <ReactLoading type="bars" color="#541f19" height={150} width={100} />
      </div>
    );
  }

  if (!blog) return <div className="text-center mt-5">Blog not found.</div>;

  return (
    <div>
      <Breadcrumb mainheading="BLOG DETAILS" title_one="BLOG" />
      <div className="container pt-5 pb-5">
        <div className="row">
          <div className="col-lg-10 mx-auto">
            <h2 className='text-center pb-5' style={{ color: 'rgb(209, 156, 101)' }}>{blog.title}</h2>
            <img
              src={blog.image}
              alt={blog.title}
              className="img-fluid rounded-xl mb-5"
              style={{ width: '100%', maxHeight: '450px', objectFit: 'cover', borderRadius: '40px' }}
            />

            <div className="blog-content pb-5" dangerouslySetInnerHTML={{ __html: blog.content }} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default BlogDetails;
